import { memo, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DataTable from "src/components/DataTable";
import {
  sortOptions,
  sourceOptions,
  stageOptions,
  tableFields,
} from "../constants";
import { connect } from "react-redux";
import { RootState } from "src/stores";
import { viewTypes, setQueryViewType } from "src/stores/basicSlices";
import {
  checkPermission,
  isAdmin,
  isManager,
  isManagerOrAdmin,
} from "src/helpers";
import { queryAPIUrls } from "src/common/apiActions";
import {
  authUserProps,
  customerDataProps,
  queryDataProps,
  queryProps,
} from "src/interfaces";
import GridViewItem from "../GridViewItem";
import ViewCustomer from "../../Customers/AddUpdate";
import { fetchUserAgents } from "src/stores/user";
import ExportQueries from "../ExportQueries";
import { updateTicketQueue } from "src/stores/ticketQueue";
import { updateQueue } from "src/stores/queue";
import { queryAssignToTicketing } from "src/stores/query";

function Component({
  currentView,
  setCurrentView,
  queries,
  authUser,
  fetchAgentsList,
  users,
  onUpdateStatus,
}: {
  currentView: viewTypes;
  setCurrentView: (type: viewTypes) => void;
  queries: queryProps;
  authUser: authUserProps;
  fetchAgentsList: () => void;
  users: any;
  onUpdateStatus: (payload: {
    id: string;
    query_id: string;
    user_id: number;
    callback?: Function;
  }) => void;
}) {
  const location = useLocation();

  const renderData = queries?.data || [];
  const navigate = useNavigate();

  const onQueryClick = (item: queryDataProps) => {
    if (checkPermission(queryAPIUrls?.updateTicketQueue)) {
      if (item?.assigned_to === null && !item?.assigned_to_user) {
        onUpdateStatus({
          id: item?.id,
          query_id: item?.id,
          user_id: 0,
        });
      }
    }
    navigate("/amadeus-query-detail/" + item?.id);
  };
  const [customer, setCustomer] = useState<customerDataProps | null>(null);
  const [agents, setAgents] = useState<any>(null);

  const [exportSlider, setExportSlider] = useState<boolean>(false);

  const onCustomerClick = (item: queryDataProps) => {
    setCustomer(item?.customer);
  };

  const defaultStageOption = queries?.selectedFilters?.stage?.toString() || "";
  const defaultSourceOption =
    queries?.selectedFilters?.source?.toString() || "";
  const defaultSortOption = queries?.selectedFilters?.sortBy?.toString() || "";

  useEffect(() => {
    fetchAgentsList();
  }, []);

  useEffect(() => {
    if (users?.agents) {
      const userOptions: any = [...users.agents]?.map((item) => ({
        label: `${item.name || ""} ${item.last_name || ""}`,
        val: item.id,
      }));

      if (userOptions.length > 0) {
        userOptions.unshift({ label: "All Agents", val: "", default: true });
        setAgents(userOptions);
      }
    }
  }, [users]);

  const onExport = () => {
    setExportSlider(true);
  };

  const defaultAgentOption = agents?.find(
    (ele) => ele?.val == queries?.selectedFilters?.agentId || ""
  );

  return (
    <>
      <DataTable
        filterData={queries?.selectedFilters}
        showColors={true}
        viewType={currentView}
        onViewChange={(view) => setCurrentView(view)}
        columns={tableFields(
          (item: queryDataProps) => {
            onQueryClick(item);
          },
          (item: queryDataProps) => {
            onCustomerClick(item);
          },
          authUser
        )}
        initialSearch={
          location?.search != "?search-queries"
            ? ""
            : location?.state?.search || ""
        }
        url={
          location?.search === "?search-queries"
            ? queryAPIUrls?.search
            : location?.search === "?all"
            ? queryAPIUrls?.all
            : queries?.selectedFilters
            ? queries?.selectedFilters?.url
            : queryAPIUrls?.amadeusGet
        }
        rowsPerPage={9}
        data={renderData}
        tableHeading="Queries"
        addBtnContent="Create New Query"
        gridViewRenderItem={(row, index) => (
          <GridViewItem
            key={index}
            item={row}
            index={index}
            onItemClick={(item) => {
              onQueryClick(item);
            }}
          />
        )}
        showSortOrder={true}
        showDateFilter={true}
        showClearFilter={true}
        statusOptions={stageOptions?.map((item) => {
          return { ...item, default: item?.val == defaultStageOption };
        })}
        sourceOptions={sourceOptions?.map((item) => {
          return { ...item, default: item?.val == defaultSourceOption };
        })}
        sortOptions={sortOptions?.map((item) => {
          return { ...item, default: item?.val == defaultSortOption };
        })}
        agentOptions={
          isManagerOrAdmin()
            ? agents?.map((item) => {
                return { ...item, default: item?.val == defaultAgentOption };
              })
            : []
        }
        sourceFilterKey="source"
        statusFilterKey="stage"
        agentsFilterKey="agentId"
        directionFilterKey="sortDirection"
        sortFilterKey="sortBy"
        toggleFilterKey="emergency"
        toggleLabel="Emergency"
        exportButton={
          checkPermission(queryAPIUrls.exportQueries) ? true : false
        }
        onExport={onExport}
      />
      <ViewCustomer
        model={customer as any}
        isView={true}
        setVisible={() => setCustomer(null)}
        visible={!!customer}
      />
      <ExportQueries
        setVisible={() => setExportSlider(false)}
        visible={exportSlider}
        dataList={
          agents
            ? agents?.map((item) => {
                return { ...item, default: item?.val == defaultAgentOption };
              })
            : []
        }
      />
    </>
  );
}

const mapStateToProps = ({
  queryViewType,
  queries,
  authUser,
  users,
}: RootState) => ({
  currentView: queryViewType,
  queries,
  authUser,
  users,
});

const mapDispatchToProps = (dispatch: any) => ({
  setCurrentView: (payload: any) => dispatch(setQueryViewType(payload)),
  fetchAgentsList: () => dispatch(fetchUserAgents()),
  onUpdateStatus: (payload: any) => dispatch(updateTicketQueue(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Component);
